module.exports = __webpack_public_path__ + "static/media/linkedin_logo.5665b787.svg";